import { useCallback } from "react";
import { Grid, Typography } from "@material-ui/core";
import { Box, Button, List, ListItem } from "~/components/UI";
import Highlighter from "react-highlight-words";
import history from "~/packages/history";
import ROUTES from "~/constants/routes";
import { useTranslation } from "react-i18next";

interface ServicesResultProps {
  data?: Api.SearchResult<Api.ServiceDto>;
  searchQuery: string;
}

const Service = ({
  service,
  searchQuery,
}: {
  searchQuery: string;
  service: Api.ServiceDto;
}) => {
  const { t } = useTranslation();

  const openService = useCallback(() => {
    history.push(
      `${ROUTES.SERVICES}?serviceId=${service.serviceId}&siteId=${service.siteId}`
    );
  }, [service.serviceId]);

  return (
    <ListItem button onClick={openService}>
      <Typography variant="body2" color="textSecondary">
        <Typography variant="body2" component="span" color="primary">
          {t("label.serviceID")}
        </Typography>
        :{" "}
        <Highlighter
          searchWords={[searchQuery]}
          textToHighlight={service.serviceId}
        />
      </Typography>
      <Typography variant="body2" color="textSecondary">
        ,{" "}
        <Highlighter
          searchWords={[searchQuery]}
          textToHighlight={service.serviceName}
        />
      </Typography>
    </ListItem>
  );
};

/**
 * @memberof GlobalSearch
 * @component
 * @desc Render of search results for the Services catalog.
 * @property {string} searchQuery - the text we are looking for
 * @property {Api.SearchResult<Api.ServiceDto>} data - api response
 */

const Services = ({ data, searchQuery }: ServicesResultProps) => {
  const { t } = useTranslation();

  const onShowAll = useCallback(() => {
    setTimeout(() => {
      history.push(`${ROUTES.SERVICES}?search=${searchQuery}`);
    }, 0);
  }, [searchQuery]);

  if (data && data.count) {
    return (
      <Box mb={4}>
        <Box py={4}>
          <Grid container alignItems="center">
            <Grid item sm>
              <Typography variant="subtitle1">
                {t("title.catalogServices")} ({data.count})
              </Typography>
            </Grid>
            <Grid item>
              <Button variant="outlined" onClick={onShowAll}>
                {t("button.showAll")}
              </Button>
            </Grid>
          </Grid>
        </Box>
        <List>
          {data.data.map((s, index) => (
            <Service key={index} searchQuery={searchQuery} service={s} />
          ))}
        </List>
      </Box>
    );
  } else {
    return null;
  }
};

export default Services;
